import { gql } from '@apollo/client';

export const ALL_IMPACT_INDICATORS_BY_INTERVENTION = gql`
  query AllImpactIndicatorsByIntervention($interventionId: ID!, $impactId: ID!) {
    indicators: allImpactIndicatorsByIntervention(interventionId: $interventionId, impactId: $impactId) {
      id
      type
      unit
      measurementUnit
      startDate
      endDate
      numberOfDataEntries
      name
    }
  }
`;
